// src/pages/Contact.jsx
import React from "react";

export default function Contact() {
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    const form = e.target;

    const name = form.name.value;
    const company = form.company.value;
    const phone = form.phone.value;
    const email = form.email.value;
    const message = form.message.value;

    const whatsappMessage = `
Hi Candid Stitch 👋

I would like to request a callback.

Name: ${name}
Company / Event: ${company}
Phone: ${phone}
Email: ${email}
Message: ${message}
    `;

    window.open(
      `https://wa.me/91XXXXXXXXXX?text=${encodeURIComponent(whatsappMessage)}`,
      "_blank"
    );
  };

  return (
    <section className="bg-black text-white min-h-screen py-28 px-6 relative overflow-hidden">

      {/* Soft Glow Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#d4a055,transparent_70%)] opacity-[0.08] pointer-events-none"></div>

      <div className="max-w-4xl mx-auto relative z-10">

        {/* HEADER */}
        <h1 className="text-5xl font-serif font-bold text-center mb-6 tracking-wide">
          Contact Us
        </h1>

        <p className="text-gray-400 text-center max-w-2xl mx-auto mb-16 text-lg">
          Need pricing, samples, or quick guidance?  
          Share your details — we’ll get back to you shortly.
        </p>

        {/* CALLBACK FORM */}
        <form
          onSubmit={handleWhatsAppSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white/5 backdrop-blur-md p-10 rounded-2xl border border-white/10"
        >
          <input
            name="name"
            placeholder="Full Name *"
            required
            className="input-field"
          />

          <input
            name="company"
            placeholder="Company / Event"
            className="input-field"
          />

          <input
            name="phone"
            placeholder="Phone Number *"
            required
            className="input-field"
          />

          <input
            name="email"
            placeholder="Email Address *"
            required
            className="input-field"
          />

          <textarea
            name="message"
            rows="4"
            placeholder="Tell us about your requirement"
            className="input-field md:col-span-2"
          />

          <button
            type="submit"
            className="
              md:col-span-2 mt-4 py-4 rounded-full border border-gray-500
              hover:border-[#d4a055] hover:text-[#d4a055]
              transition-all tracking-wide text-lg font-medium
            "
          >
            Request Callback
          </button>
        </form>

        {/* DIRECT CONTACT OPTIONS */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 mt-16 text-gray-400">

          <a
            href="https://wa.me/918446511725"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#d4a055] transition text-lg"
          >
            💬 Chat on WhatsApp
          </a>

          <a
            href="mailto:hello@candidstitch.com"
            className="hover:text-[#d4a055] transition text-lg"
          >
            ✉️ hello@candidstitch.com
          </a>

        </div>
      </div>

      {/* INPUT STYLES */}
      <style>{`
        .input-field {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.15);
          padding: 14px 18px;
          border-radius: 12px;
          color: white;
          outline: none;
        }

        .input-field::placeholder {
          color: #9ca3af;
        }

        .input-field:focus {
          border-color: #d4a055;
          box-shadow: 0 0 0 1px rgba(212,160,85,0.4);
        }
      `}</style>
    </section>
  );
}
